export default __webpack_public_path__ + "static/media/menuL_icon_01.18bf9e2a.png";